import { useMutation } from "@tanstack/react-query";
import { feedbackApi } from "../api/feedbackApi";
import { trackEvent } from "../../../shared/lib/analytics";

export function useSendFeedbackMutation() {
  return useMutation({
    mutationFn: feedbackApi.send,
    onSuccess: (_, { category }) => trackEvent("feedback_sent", { category }),
  });
}
